import React from 'react';
import ServiceFlowTemplateWorkspace from '@/components/Events/ServiceFlow/ServiceFlowTemplateWorkspace';

/** New Service Flow template (spec §3.4 — dedicated workspace, not a modal). */
const CreateServiceFlowTemplateScreen = () => (
    <ServiceFlowTemplateWorkspace templateID={null} />
);

export default CreateServiceFlowTemplateScreen;
